import React from 'react';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  fullWidth?: boolean;
}

const variantClass: Record<Variant, string> = {
  primary:   'btn-primary',
  secondary: 'btn-secondary',
  danger:    'btn-danger',
  ghost:     'btn-ghost',
};

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  loading = false,
  fullWidth = true,
  className = '',
  disabled,
  children,
  ...rest
}) => {
  const base = variantClass[variant];
  const width = variant === 'ghost' ? '' : fullWidth ? 'w-full' : 'w-auto';

  return (
    <button
      className={`${base} ${width} ${loading ? 'pointer-events-none' : ''} ${className}`}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <span
          className="mr-2 inline-block h-3.5 w-3.5 animate-spin rounded-full border-[0.2rem] border-[var(--ui-white-alpha-50)] border-t-background-surface-01"
          aria-hidden="true"
        />
      ) : null}
      {children}
    </button>
  );
};

export default Button;
